import axios from 'axios';

import { getLocationId, getRegisterId } from 'helpers/session';
import CustomerService from 'root/apps/QuoteMachineIntegration/services/CustomerService';
import LocationService from 'root/apps/QuoteMachineIntegration/services/LocationService';
import { AccountStatementReferenceResponse } from 'root/apps/QuoteMachineIntegration/state';
import InvoicingCustomer from 'root/apps/QuoteMachineIntegration/state/Customer';
import Location from 'root/apps/QuoteMachineIntegration/state/Location';

import { AccountStatementSendPayload } from '../state/AccountStatementSendPayload';

export default class AccountStatementService {
  static buildInvoicingCreditAccountId(creditAccountId: string): string {
    return `ls-retail_${creditAccountId}`;
  }

  static async createNewAccountStatement(
    creditAccountId: string,
    customerId: string
  ): Promise<AccountStatementReferenceResponse> {
    try {
      const locationId = getLocationId();
      const invoicingCreditAccountId =
        AccountStatementService.buildInvoicingCreditAccountId(creditAccountId);

      const locationData = await LocationService.getLocation(locationId);
      const location = new Location(locationData);

      const customerData = await CustomerService.getCustomer(customerId);
      const customerDetails = new InvoicingCustomer(customerData);

      const result = await axios.post(
        `/admin/invoicing/credit-accounts/${invoicingCreditAccountId}/account-statements`,
        {
          location,
          customerDetails,
          lsRegisterId: getRegisterId(),
          lsCreditAccountId: creditAccountId,
        }
      );
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  static async createAndSendAccountStatement(
    creditAccountId: string,
    customerId: string,
    payload: AccountStatementSendPayload
  ) {
    const reference = await AccountStatementService.createNewAccountStatement(
      creditAccountId,
      customerId
    );
    const statementId = reference.id;
    const statementIdentifier = reference.attributes.identifier;
    const sendResult = await AccountStatementService.sendAccountStatement(statementId, payload);
    return { ...sendResult, statementIdentifier };
  }

  // 202 response means that we will attempt to send an email but does not mean that the email has already been delivered to the recipient(s)
  static async sendAccountStatement(
    accountStatementId: string,
    payload: AccountStatementSendPayload
  ) {
    try {
      const { data, status } = await axios.post(
        `/admin/invoicing/account-statements/${accountStatementId}/send`,
        payload
      );
      return { data, status };
    } catch (error) {
      throw error;
    }
  }
}
